import api from './client.js'

export const pointsAPI = {
  getMyBalance:        ()                         => api.get('/points/me'),
  getLeaderboard:      (limit = 10)               => api.get(`/points/leaderboard?limit=${limit}`),
  getAllBalances:       ()                         => api.get('/points/balances'),
  getAllTransactions:   (limit = 500)              => api.get(`/points/transactions?limit=${limit}`),
  getUserTransactions: (userId)                   => api.get(`/points/users/${userId}/transactions`),
  addTransaction:      (userId, data)             => api.post(`/points/users/${userId}/transactions`, data),
  deleteTransaction:   (userId, txId)             => api.delete(`/points/users/${userId}/transactions/${txId}`),
  clearTransactions:   (userId)                   => api.delete(`/points/users/${userId}/transactions`),
  awardTournament:     (tournamentId, placements) => api.post(`/points/tournament/${tournamentId}/award`, { placements }),
}
